/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    },
    {
        id: 'nomina',
        title: 'Nómina',
        type: 'collapsable',
        icon: 'heroicons_outline:currency-dollar',
        children: [
            { id: 'nomina-dashboard', title: 'Dashboard', type: 'basic', icon: 'heroicons_outline:chart-square-bar', link: '/nomina' },

            // Configuración
            {
                id: 'nomina-config', title: 'Configuración', type: 'collapsable', icon: 'heroicons_outline:cog',
                children: [
                    { id: 'nomina-conceptos', title: 'Conceptos y Parámetros', type: 'basic', link: '/nomina/configuracion' },
                    { id: 'nomina-empresas', title: 'Nóminas Empresa', type: 'basic', link: '/nomina/nominas' },
                ]
            },

            // Gestión de Personal
            {
                id: 'nomina-gestion', title: 'Gestión Personal', type: 'collapsable', icon: 'heroicons_outline:user-group',
                children: [
                    { id: 'nomina-contratos', title: 'Contratos', type: 'basic', link: '/nomina/contratos' },
                    { id: 'nomina-novedades', title: 'Novedades', type: 'basic', link: '/nomina/novedades' },
                    { id: 'nomina-embargos', title: 'Embargos', type: 'basic', link: '/nomina/embargos' },
                    { id: 'nomina-descuentos-fijos', title: 'Descuentos / Ingresos Fijos', type: 'basic', link: '/nomina/descuentos-fijos' },
                    { id: 'nomina-eventos', title: 'Eventos Laborales', type: 'basic', link: '/nomina/eventos' },
                    { id: 'nomina-libranzas', title: 'Libranzas', type: 'basic', link: '/nomina/libranzas' },
                ]
            },

            // Periodos
            { id: 'nomina-periodos', title: 'Periodos', type: 'basic', icon: 'heroicons_outline:calendar', link: '/nomina/periodos' },

            // Liquidación
            {
                id: 'nomina-liquidacion', title: 'Liquidación', type: 'collapsable', icon: 'heroicons_outline:calculator',
                children: [
                    { id: 'nomina-liq-lista', title: 'Liquidaciones', type: 'basic', link: '/nomina/liquidacion' },
                    { id: 'nomina-liq-masiva', title: 'Masiva / Multi-empresa', type: 'basic', link: '/nomina/liquidacion/masiva' },
                    { id: 'nomina-liq-retiro', title: 'Liquidación de Retiro', type: 'basic', link: '/nomina/liquidacion/retiro' },
                ]
            },

            // Libros Laborales
            {
                id: 'nomina-libros', title: 'Libros Laborales', type: 'collapsable', icon: 'heroicons_outline:book-open',
                children: [
                    { id: 'nomina-vacaciones', title: 'Vacaciones', type: 'basic', link: '/nomina/libros' },
                    { id: 'nomina-cesantias', title: 'Cesantías', type: 'basic', link: '/nomina/libros' },
                    { id: 'nomina-incapacidades', title: 'Incapacidades', type: 'basic', link: '/nomina/libros' },
                ]
            },

            // Provisiones + Aportes
            { id: 'nomina-provisiones', title: 'Provisiones', type: 'basic', icon: 'heroicons_outline:chart-pie', link: '/nomina/provisiones' },
            { id: 'nomina-aportes', title: 'Aportes SS', type: 'basic', icon: 'heroicons_outline:shield-check', link: '/nomina/aportes-ss' },

            // Análisis
            {
                id: 'nomina-analisis', title: 'Análisis', type: 'collapsable', icon: 'heroicons_outline:beaker',
                children: [
                    { id: 'nomina-simulaciones', title: 'Simulaciones', type: 'basic', link: '/nomina/simulaciones' },
                ]
            },

            // Documentos
            {
                id: 'nomina-documentos', title: 'Documentos', type: 'collapsable', icon: 'heroicons_outline:document-download',
                children: [
                    { id: 'nomina-pila', title: 'PILA', type: 'basic', link: '/nomina/documentos/pila' },
                    { id: 'nomina-ne', title: 'Nómina Electrónica', type: 'basic', link: '/nomina/documentos/ne' },
                    { id: 'nomina-banco', title: 'Archivo Banco', type: 'basic', link: '/nomina/documentos/banco' },
                    { id: 'nomina-comprobantes', title: 'Comprobantes', type: 'basic', link: '/nomina/comprobantes' },
                    { id: 'nomina-saldos-rojos', title: 'Saldos en Rojo', type: 'basic', link: '/nomina/saldos-rojos' },
                ]
            },

            // Reportes + Auditoría + Autoservicio
            { id: 'nomina-reportes', title: 'Reportes', type: 'basic', icon: 'heroicons_outline:presentation-chart-bar', link: '/nomina/reportes' },
            { id: 'nomina-auditoria', title: 'Auditoría', type: 'basic', icon: 'heroicons_outline:eye', link: '/nomina/auditoria' },
            { id: 'nomina-autoservicio', title: 'Autoservicio', type: 'basic', icon: 'heroicons_outline:user-circle', link: '/nomina/autoservicio' },

            // Administración
            {
                id: 'nomina-admin', title: 'Administración', type: 'collapsable', icon: 'heroicons_outline:cog',
                children: [
                    { id: 'nomina-programacion', title: 'Programación Liquidaciones', type: 'basic', link: '/nomina/programacion' },
                    { id: 'nomina-accesos', title: 'Permisos por Nómina', type: 'basic', link: '/nomina/accesos' },
                ]
            },
        ]
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
// Mismo orden de LIAS (shared/constants/lias.constants.ts). Las LIAs que el usuario no tiene
// las marca ModernLayoutComponent con candado y las manda a su vitrina.
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'control-afiliacion',
        title: 'LIA Gestión Procesos',
        type : 'basic',
        link : '/contrataciones'
    },
    {
        id   : 'home-afilicacio',
        title: 'LIA Afiliación',
        type : 'basic',
        link : '/home/afiliacion'
    },
    {
        id   : 'sst',
        title: 'LIA SST',
        type : 'basic',
        link : '/sst'
    },
    {
        id   : 'nomina-horizontal',
        title: 'LIA Nómina',
        type : 'basic',
        link : '/nomina'
    },
    {
        id   : 'formacion',
        title: 'LIA Formación',
        type : 'basic',
        link : '/formacion'
    }
];
